import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/common/Footer';
import Logo from '../components/common/Logo';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const Privacy = () => {
  // console.log('Mounting Privacy');

  return (
    <motion.div
      className="min-h-screen bg-gray-900 flex flex-col"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <header className="border-b border-gray-800 py-4 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            <span>Back</span>
          </Link>
          <div className="flex justify-center">
            <Logo size="small" />
          </div>
          <div className="w-20"></div> {/* Empty div for spacing */}
        </div>
      </header>
      
      <div className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">Privacy Policy</h1>
          
          <div className="prose prose-sm sm:prose-base lg:prose-lg prose-invert max-w-none">
            <p className="text-lg text-gray-300 mb-8">
              At Open Org, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information.
            </p>
            
            <h2>1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us, such as:
            </p>
            <ul>
              <li>Account information (name, email address, password)</li>
              <li>Profile information (job title, company, etc.)</li>
              <li>Payment information (processed securely through our payment provider)</li>
              <li>Communications you send to us</li>
            </ul>
            
            <p>
              We also automatically collect certain information when you use our Service:
            </p>
            <ul>
              <li>Log information (IP address, browser type, pages visited, etc.)</li>
              <li>Device information (hardware model, operating system, unique device identifiers)</li>
              <li>Usage information (features you use, content you access)</li>
              <li>Cookies and similar technologies</li>
            </ul>
            
            <h2>2. How We Use Your Information</h2>
            <p>
              We use the information we collect to:
            </p>
            <ul>
              <li>Provide, maintain, and improve our Service</li>
              <li>Process transactions and manage your account</li>
              <li>Send you technical notices, updates, and administrative messages</li>
              <li>Respond to your comments, questions, and provide customer service</li>
              <li>Monitor and analyze trends, usage, and activities in connection with our Service</li>
              <li>Personalize and improve your experience</li>
              <li>Detect, investigate, and prevent fraudulent transactions and other illegal activities</li>
            </ul>
            
            <h2>3. Sharing of Information</h2>
            <p>
              We may share your information as follows:
            </p>
            <ul>
              <li>With service providers who perform services on our behalf</li>
              <li>In response to legal process or when we believe disclosure is necessary to protect our rights</li>
              <li>With your consent or at your direction</li>
            </ul>
            
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect the security of your information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
            
            <h2>5. Your Choices</h2>
            <p>
              You can access and update certain information about your account through your account settings. You can also opt out of receiving promotional communications from us by following the instructions in those communications.
            </p>
            
            <h2>6. Cookies</h2>
            <p>
              Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of our Service.
            </p>
            
            <h2>7. Children's Privacy</h2>
            <p>
              Our Service is not directed to children under 16, and we do not knowingly collect personal information from children under 16. If we learn we have collected personal information from a child under 16, we will delete that information.
            </p>
            
            <h2>8. International Data Transfers</h2>
            <p>
              Your information may be transferred to, and processed in, countries other than the country in which you reside. These countries may have data protection laws that are different from the laws of your country.
            </p>
            
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
            
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at hello@openorg.fyi
            </p>
            
            <h2>11. Data Controller</h2>
            <p>
              The data controller responsible for your personal information is Open Org Group Ltd.
            </p>
            
            <p className="text-sm text-gray-500 mt-8">
              Last updated: May 1, 2025
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </motion.div>
  );
};

export default Privacy; 